import { Theme } from '@material-ui/core/styles'

/**
 * Card geometry shared by a panel and its loading skeleton.
 *
 * §8.4 asks for one styles file per component, and these two rules are the one
 * case where that would force a duplicate: NotificationListSkeleton draws
 * placeholders shaped like the real rows, so it needs the same padding and
 * margin the panels use. Two copies would drift, and the skeleton would stop
 * matching what it stands in for — visible as a layout jump when the data
 * lands.
 *
 * Same reasoning as the COLUMNS constant in §2: one source, consumed by every
 * component that needs it, rather than a literal repeated per file.
 */
export const inboxCardShape = (theme: Theme) => ({
  marginBottom: theme.spacing(1.5),
  padding: theme.spacing(2)
})

export const resourceCardShape = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1.5)
})
